import React from "react";
import { motion } from "framer-motion";
import { Rocket } from "lucide-react";

export default function AIStatusOrb({ state = "idle", size = 56 }) {
  // state: running | paused | idle
  const color =
    state === "running"
      ? "#2FE7A1"
      : state === "paused"
        ? "#FFB020"
        : "#7F8AA3";
  return (
    <div
      className="relative inline-flex items-center justify-center shrink-0"
      style={{ width: size, height: size }}
      aria-label={`AI ${state}`}
      data-testid={`ai-status-orb-${state}`}
    >
      {state === "running" ? (
        <>
          <motion.span
            className="absolute inset-0 rounded-full"
            style={{ background: color, opacity: 0.18, filter: "blur(10px)" }}
            animate={{ scale: [1, 1.18, 1] }}
            transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.span
            className="absolute inset-2 rounded-full"
            style={{ background: color, opacity: 0.25 }}
            animate={{ scale: [1, 1.08, 1], opacity: [0.25, 0.35, 0.25] }}
            transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
          />
        </>
      ) : null}
      <div
        className="relative rounded-full flex items-center justify-center"
        style={{
          width: size * 0.68,
          height: size * 0.68,
          background: `radial-gradient(circle at 30% 30%, ${color}AA 0%, ${color}33 80%)`,
          border: `1px solid ${color}66`,
          boxShadow: state === "running" ? `0 0 14px ${color}66` : "none",
        }}
      >
        <Rocket className="h-4 w-4" style={{ color: state === "idle" ? "#B9C3D9" : "#0B0D10" }} />
      </div>
    </div>
  );
}
